import { TextField } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import {
    filterLabelByKey,
    filterUnitByKey,
    validateTextField
} from '../../../handler/VersionListHandler';
import Constant from '@/common/constant/Constant';
import I18n from '@/rI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function BasicSetting({
    value,
    setValue,
    internalQACounterSettings,
    deskService,
    knowledgeService,
    setIsEdit,
    ...props
}) {
    useTranslationSubscription();
    const handleOnChange = (field, e) => {
        const fieldKey = field[0];
        const inputValue = e.target.value;
        const isNumberOfExWebAPI = fieldKey === Constant.SETTING_VERSION_LABEL.NUMBER_OF_EX_WEB_API;

        setIsEdit(true);
        setValue(prev => ({
            ...prev,
            [fieldKey]: {
                ...prev[fieldKey],
                ...(isNumberOfExWebAPI
                    ? {
                        number: {
                            ...prev[fieldKey].number,
                            value: inputValue,
                            error: ''
                        }
                    }
                    : {
                        value: inputValue,
                        error: ''
                    })
            }
        }));
    };

    const handleOnBlur = (field, e) => {
        const fieldKey = field[0];
        const fieldValue = field[1];
        const blurValue = e.target.value.trim();
        const isUnlimited = fieldValue?.isUseUnlimited?.value;
        let newValue = {};
        let error = '';

        const isNumberOfExWebAPI = fieldKey === Constant.SETTING_VERSION_LABEL.NUMBER_OF_EX_WEB_API;

        if (Utils.isEmptyString(blurValue)) {
            error = I18n.get('COMMSG014');
            newValue = isNumberOfExWebAPI && !isUnlimited
                ? {
                    number: {
                        ...fieldValue.number,
                        error
                    }
                }
                : {
                    error
                };
        } else {
            const rules = isNumberOfExWebAPI && !isUnlimited
                ? fieldValue.number.rules
                : fieldValue.rules;

            error = validateTextField(rules, blurValue, fieldKey);

            newValue = isNumberOfExWebAPI && !isUnlimited
                ? {
                    number: {
                        ...fieldValue.number,
                        value: blurValue,
                        error
                    }
                }
                : {
                    value: blurValue,
                    error
                };
        }

        setValue(prev => ({
            ...prev,
            [fieldKey]: {
                ...prev[fieldKey],
                ...newValue
            }
        }));
    };

    const handleDisabled = (item, dataSetting) => {
        const deskItems = [
            Constant.SETTING_VERSION_LABEL.NUMBER_OF_QA_COUNTERS,
            Constant.SETTING_VERSION_LABEL.NUMBER_OF_SUPPORTED_COUNTERS,
            Constant.SETTING_VERSION_LABEL.NUMBER_OF_B2C
        ];

        return (
            (deskItems.includes(item) && !deskService) ||
            (item === Constant.SETTING_VERSION_LABEL.NUMBER_OF_KNOWLEDGES && !knowledgeService) ||
            (item === Constant.SETTING_VERSION_LABEL.NUMBER_OF_EX_WEB_API && dataSetting?.isUseUnlimited?.value)
        );
    };
    

    return (
        <>
            <div className="setting-description border-bottom">
                <span className="description-detail col-5">{tr('上限項目')}</span>
                <span className="description-detail col-5">{tr('上限数')}</span>
            </div>
            {Object.entries(value).map((item) => {
                const [key, config] = item;

                if (key === Constant.SETTING_VERSION_LABEL.NUMBER_OF_EX_WEB_API) {
                    return (
                        <></>
                    );
                }

                // default render
                return (
                    <div className="setting-item border-bottom" key={key}>
                        <label className="setting-label col-5">{tr(filterLabelByKey(key))}</label>
                        <div className="setting-action col-5">
                            <TextField
                                className="form-control-input form-control-wrapInput form-control-hg32 setting-input"
                                variant="outlined"
                                spellCheck={false}
                                type="text"
                                value={config.value}
                                disabled={handleDisabled(key)}
                                onChange={e => handleOnChange(item, e)}
                                onBlur={e => handleOnBlur(item, e)}
                                onWheel={e => e.target.blur()}
                                helperText={tr(config.error)}
                                error={!Utils.isEmptyString(config.error)}
                            />
                            <label className="setting-unit">{tr(filterUnitByKey(config.unit))}</label>
                        </div>
                    </div>
                );
            })}
        </>
    );
}

export default BasicSetting;
